import { MultiSelectInput } from '../../components/form/inputs/MultiSelectInput';
import { Controlled_BooleanInput } from '../../components/inputs/controlled/Controlled_BooleanInput';
import { Controlled_BooleanSwitchInput } from '../../components/inputs/controlled/Controlled_BooleanSwitchInput';
import { Controlled_ColorInput } from '../../components/inputs/controlled/Controlled_ColorInput';
import { Controlled_EnumArray } from '../../components/inputs/controlled/Controlled_EnumArray';
import { Controlled_EnumInput } from '../../components/inputs/controlled/Controlled_EnumInput';
import { Controlled_MultilineStringInput } from '../../components/inputs/controlled/Controlled_MultilineStringInput';
import { Controlled_NumberInput } from '../../components/inputs/controlled/Controlled_NumberInput';
import { Controlled_NumericInput } from '../../components/inputs/controlled/Controlled_NumericInput';
import { Controlled_ReferenceInput } from '../../components/inputs/controlled/Controlled_ReferenceInput';
import { Controlled_SecretInput } from '../../components/inputs/controlled/Controlled_SecretInput';
import { Controlled_SelectInput } from '../../components/inputs/controlled/Controlled_SelectInput';
import { Controlled_StringInput } from '../../components/inputs/controlled/Controlled_StringInput';

export const ControlledInputs = {
    Enum: Controlled_EnumInput,
    Select: Controlled_SelectInput,
    Number: Controlled_NumberInput,
    Reference: Controlled_ReferenceInput,
    String: Controlled_StringInput,
    Numeric: Controlled_NumericInput,
    MultilineString: Controlled_MultilineStringInput,
    Boolean: Controlled_BooleanInput,
    BooleanSwitch: Controlled_BooleanSwitchInput,
    Secret: Controlled_SecretInput,
    Color: Controlled_ColorInput,
    EnumArray: Controlled_EnumArray,
    MultiSelect: MultiSelectInput,
    // RichText: Controlled_RichText,
};
